import Footer from "../components/footer/footer";
import Navbar from "../components/navbar/navbar";
import Contact from "./../components/contactcomponents/contact";
import Map from "./../components/empty";
import Header from "./../components/contactcomponents/header";
import Newsletter from "./../components/homecomponents/newsletter4";

const Contactpage = () => {
    return(
        <div>
            <Navbar/>
            <Header/>
            <Contact/>
            <Map/>
            <Newsletter/>
            <Footer/>
        </div>
    )
}
export default Contactpage;